import { render } from "./CmPowerByBanner.vue?vue&type=template&id=c6b89a32&scoped=true"
import script from "./CmPowerByBanner.vue?vue&type=script&lang=js"
export * from "./CmPowerByBanner.vue?vue&type=script&lang=js"

import "./CmPowerByBanner.vue?vue&type=style&index=0&id=c6b89a32&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6b89a32"]])

export default __exports__